var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dz-badge"},[_vm._t("default"),(_vm.txt === 'new')?_c('div',{staticClass:"badge-new",style:(_vm.txtStyle)}):(!!_vm.txt)?_c('span',{staticClass:"badge",style:(_vm.txtStyle)},[_vm._v(_vm._s(_vm.txt))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }